import apiService from '../utils/apiService';

// Backend namespace for the SGM (sales agent) program.
const API_PREFIX = 'sgm';

const getAuthConfig = () => {
  const token = localStorage.getItem('s_a_t');
  return token
    ? {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    : {};
};

const sgmAuth = async (assistantId, posCode, empId) => {
  const response = await apiService.post(`${API_PREFIX}/auth`, {
    data: {
      assistantId,
      ...(posCode ? { posCode } : {}),
      ...(empId ? { empId } : {})
    }
  });

  return response?.data;
};

const checkPos = async (posCode) => {
  const response = await apiService.get(
    `${API_PREFIX}/pos/${posCode}/check`,
    getAuthConfig()
  );

  return response?.data;
};

const generateQrCode = async () => {
  const response = await apiService.get(
    `${API_PREFIX}/qr/generate`,
    getAuthConfig()
  );

  return response?.data;
};

const getMe = async () => {
  const response = await apiService.get(`${API_PREFIX}/me`, getAuthConfig());

  return response?.data;
};

const validateQrCode = async (token) => {
  const response = await apiService.post(`${API_PREFIX}/qr/validate`, {
    data: {
      token
    },
    ...getAuthConfig()
  });

  return response?.data;
};

const getCertificates = async (nominal, partnerId) => {
  const response = await apiService.get(`${API_PREFIX}/certificates`, {
    params: {
      nominal,
      partnerId
    },
    ...getAuthConfig()
  });

  return response?.data;
};

const buyCertificate = async (id, number) => {
  const response = await apiService.post(
    `${API_PREFIX}/certificates/${id}/buy`,
    {
      ...(number ? { data: { number } } : {}),
      ...getAuthConfig()
    }
  );

  return response?.data;
};

const getBalance = async () => {
  const response = await apiService.get(
    `${API_PREFIX}/me/balance`,
    getAuthConfig()
  );

  return response?.data;
};

const getBalanceHistory = async (page, limit, operationType) => {
  const response = await apiService.get(`${API_PREFIX}/me/balance/history`, {
    params: {
      page,
      limit,
      operationType
    },
    ...getAuthConfig()
  });

  return response?.data;
};

const getRewards = async (page, limit) => {
  const response = await apiService.get(`${API_PREFIX}/me/rewards`, {
    params: {
      page,
      limit
    },
    ...getAuthConfig()
  });

  return response?.data;
};

const getRewardById = async (id) => {
  const response = await apiService.get(
    `${API_PREFIX}/me/rewards/${id}`,
    getAuthConfig()
  );

  return response?.data;
};

const getQrCodes = async (page, limit) => {
  const response = await apiService.get(`${API_PREFIX}/me/qr-codes`, {
    params: {
      page,
      limit
    },
    ...getAuthConfig()
  });

  return response?.data;
};

const getQrCodeById = async (id) => {
  const response = await apiService.get(
    `${API_PREFIX}/me/qr-codes/${id}`,
    getAuthConfig()
  );

  return response?.data;
};

const regenerateQrCode = async (id) => {
  const response = await apiService.post(
    `${API_PREFIX}/me/qr-codes/${id}/regenerate`,
    getAuthConfig()
  );

  return response?.data;
};

const createFeedback = async (name, email, comment) => {
  const response = await apiService.post(`${API_PREFIX}/feedback`, {
    data: {
      name,
      email,
      comment
    },
    ...getAuthConfig()
  });

  return response?.data;
};

const createCallbackRequest = async () => {
  const response = await apiService.post(
    `${API_PREFIX}/callback-request`,
    getAuthConfig()
  );

  return response?.data;
};

export default {
  sgmAuth,
  checkPos,
  generateQrCode,
  validateQrCode,
  getCertificates,
  buyCertificate,
  getBalance,
  getBalanceHistory,
  getRewards,
  getRewardById,
  getQrCodes,
  getQrCodeById,
  regenerateQrCode,
  createFeedback,
  createCallbackRequest,
  getMe
};
